import React, { useRef, useState } from "react";
import Cleave from "cleave.js/react";
import ToggleSwitch from "./ToggleSwitch";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    root: {
        // display: 'flex',
        // flexDirection: 'row',
        // gap: '10px',
    },
});

function BatchTime({ onChange, errors, value }) {
    const batchRef = useRef(null);
    const classes = useStyles();
    const [time, setTime] = useState("06:00");
    const [meridiem, setMeridiem] = useState("PM");

    const handleTimeChange = (e) => {
        setTime(e.target.value);
        onChange(`${e.target.value} ${meridiem}`);
    };

    const handleMeridiemChange = (e, value) => {
        setMeridiem(value);
        onChange(`${time} ${value}`);
    };

    return (
        <div className="row">
            <div className="col-6 col-md-6 col-sm-6">
                <div class="input-wrapper batch-time">
                    <label for="batch_time">Batch Time</label>
                    <Cleave
                        placeholder="      :"
                        options={{
                            time: true,
                            timePattern: ["h", "m"],
                            timeFormat: 12,
                        }}
                        id="batch_time"
                        onChange={handleTimeChange}
                        ref={batchRef}
                        value={time}
                    />
                    <span for="batch_time">EST</span>
                </div>
            </div>
            <div className="col-6 col-md-6 col-sm-6">
                <ToggleSwitch
                    handleChange={handleMeridiemChange}
                    value={meridiem}
                    options={[
                        { key: "AM", value: "AM" },
                        { key: "PM", value: "PM" },
                    ]}
                    name="meridiem"
                />
            </div>
        </div>
    );
}

export default BatchTime;
